import { call, put } from 'redux-saga/effects';

import api from 'api';
import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { closeModal } from 'store/modals/actions';
import { notifyError } from 'store/notifications/actions';

import { normalizeSubscriptionPeriods } from 'helpers/utils';

import { fetchSubscriptionsError } from '../actions';

import { handleAuthError } from './utils';

export function* getSubscription() {
    try {
        const response: ISubscriptionWellfunnel[] = yield call(api.subscriptions.getSubscriptions);

        return normalizeSubscriptionPeriods(response);
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(fetchSubscriptionsError());
        yield put(closeModal());
        yield put(notifyError({ message: 'basics.appError' }));
    }
}
